<template lang="pug">
    alert(v-if="show", clickable, type="warning", @click="$router.push({ name: 'third-party-tokens' })")
        template Create a ScholarPack Rest token
</template>

<script>
import gql from "graphql-tag";
import Alert from "@/components/ui/Alert";

export default {
	components: {
		Alert
	},
	computed: {
		show() {
			if (this.SchoolMigration && this.SchoolMigration.migrate_to_mis_identity === "scholarpackrest" && !this.SchoolMigration.completed_at) {
				return true;
			}

			return false;
		}
	},
	apollo: {
		SchoolMigration: {
			query: gql`
				query getSchoolMigration {
					User {
						id
						School {
							id
							SchoolMigration {
								id
								migrate_to_mis_identity
								completed_at
							}
						}
					}
				}
			`,
			update: r => r.User.School.SchoolMigration
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/apps/appsList/cards/admin/ScholarPackCreateTokenNotice.vue